const updateGroupDeleteStates = () => {
    document.querySelectorAll('.folder-edit-mode-group').forEach(group => {
        const container         = group.querySelector('[data-sortable-folder-container]');
        const isEmpty           = container.querySelectorAll('.folder-edit-mode-item:not(.ghost)').length === 0;
        const deleteButton      = group.querySelector('[data-group-delete]');
        const deletePlaceholder = group.querySelector('[data-group-delete-placeholder]');

        if (deleteButton) {
            deleteButton.classList.toggle('folder-edit-mode-hidden', !isEmpty);
        }

        if (deletePlaceholder) {
            deletePlaceholder.classList.toggle('folder-edit-mode-hidden', isEmpty);
        }
    });
};

const handleFolderDrop = async (event) => {
    const rearrangeContainer = document.querySelector('.folder-edit');

    if (!rearrangeContainer) {
        return;
    }

    const sortUrl = rearrangeContainer.dataset.sortFoldersUrl;
    const form    = new FormData();

    rearrangeContainer.querySelectorAll('[data-sortable-folder-container]').forEach((folderContainer, groupIndex) => {
        form.append(`groups[${groupIndex}][groupId]`, folderContainer.dataset.folderGroupId);

        folderContainer.querySelectorAll('.folder-edit-mode-item:not(.ghost)').forEach((item, folderIndex) => {
            form.append(`groups[${groupIndex}][folders][${folderIndex}]`, item.dataset.folderId);
        });
    });

    const destinationGroup = event.detail.destinationContainer?.closest('.folder-edit-mode-group');

    if (destinationGroup) {
        destinationGroup.classList.add('drop-highlight');
        setTimeout(() => destinationGroup.classList.remove('drop-highlight'), 600);
    }

    updateGroupDeleteStates();

    await fetch(sortUrl, {
        method: 'POST',
        body: form,
    });
};

const handleGroupDrop = async (event) => {
    const rearrangeContainer = document.querySelector('.folder-edit');

    if (!rearrangeContainer) {
        return;
    }

    const sortUrl = rearrangeContainer.dataset.sortGroupsUrl;
    const form    = new FormData();

    rearrangeContainer.querySelectorAll('.folder-edit-mode-group:not(.ghost)').forEach(group => {
        form.append('groupOrder[]', group.dataset.folderGroupId);
    });

    await fetch(sortUrl, {
        method: 'POST',
        body: form,
    });
};

document.addEventListener('sortabledrop', (event) => {
    if (event.target.classList.contains('folder-edit-mode-item')) {
        handleFolderDrop(event);
    }

    if (event.target.classList.contains('folder-edit-mode-group')) {
        handleGroupDrop(event);
    }
});

document.addEventListener('mousedown', (event) => {
    if (event.target.closest('[data-folder-edit-action]')) {
        event.stopPropagation();
    }
}, true);

document.addEventListener('touchstart', (event) => {
    if (event.target.closest('[data-folder-edit-action]')) {
        event.stopPropagation();
    }
}, true);
